import React from 'react';
import { cnHeader, cnHeaderBase, cnHeaderLogoWrapper, cnHeaderContent, cnHeaderActions } from './Header.const';
import { YandexLogo } from './Logo/Header-Logo';
import './Header.css';
/**
 * Компонент шапки.
 * @param {HeaderProps} props
 *
 */
export var Header = function (_a) {
    var actions = _a.actions, children = _a.children, className = _a.className, innerRef = _a.innerRef, logo = _a.logo;
    return (React.createElement("header", { ref: innerRef, className: cnHeader(null, [className]) },
        React.createElement("div", { className: cnHeaderBase },
            React.createElement("div", { className: cnHeaderLogoWrapper }, logo || React.createElement(YandexLogo, null)),
            React.createElement("div", { className: cnHeaderContent }, children),
            actions && React.createElement("div", { className: cnHeaderActions }, actions))));
};
Header.displayName = 'Header';
